'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPersistedThreadsArray = undefined;

var _reselect = require('reselect');

var _getThreads = require('./getThreads');

var _isPersistedThread = require('../../threads/operators/isPersistedThread');

var getPersistedThreadsArray = exports.getPersistedThreadsArray = (0, _reselect.createSelector)([_getThreads.getThreads], function (threads) {
  return threads.valueSeq().filter(_isPersistedThread.isPersistedThread).toArray();
});